export * from './CollectionPageFooter';
